import { render, staticRenderFns } from "./UiBlockForm.vue?vue&type=template&id=4b9e5a40&scoped=true"
import script from "./UiBlockForm.vue?vue&type=script&lang=js"
export * from "./UiBlockForm.vue?vue&type=script&lang=js"
import style0 from "./UiBlockForm.vue?vue&type=style&index=0&id=4b9e5a40&prod&scoped=true&lang=css"
import style1 from "./uiBlockShared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e5a40",
  null
  
)

export default component.exports